module.exports = __webpack_public_path__ + "d25d6e022710762a5422ebdcd29c1958.svg";